import React, {Component, Fragment} from 'react';
import Select from 'react-select';
import onClickOutside from 'react-onclickoutside'
import {withNamespaces} from 'react-i18next';
import api from '../../apiV2/adsApi';

class AdsFinder extends Component {
    /* istanbul ignore next */
    constructor() {
        super();

        this.state = {
            options: [],
            inputed: "",
            open: false
        };

        this.select = React.createRef();
        this.inputed = "";
    }

    componentWillReceiveProps(nextProps) {
        let open = false;
        let value = nextProps.value;
        if (value && this.inputed !== value) {
            this.inputed = value;

            if (this.select.current.props) {
                if (value.length >= 3 && nextProps.preventFind !== true) {
                    open = true;
                    api.findByStreet(value).then(result => {
                        let options = [];

                        for (let address of result) {
                            options.push({
                                adsAddressId: address.adsAddressId,
                                value: address.pointX + "|" + address.pointY,
                                label: address.level5Name + " " + address.level7Name + ", " + address.level3Name + ", " + address.level2Name,
                                shortAddress: address.level5Name + " " + address.level7Name
                            });
                        }
                        this.setState({
                            options: options
                        });

                        if (options.length > 0) {
                            this.setState({
                                open: open
                            });
                        }
                    });
                }
            }
        }

        if(open !== this.state.open){
            this.setState({
                open: false
            });
        }
    }

    handleChange = (value) => {
        this.props.inputValue(value);
        this.setState({
            open: false
        });
    };

    handleClickOutside() {
        this.setState({open: false})
    }

    render() {
        return (
            <Fragment>
                <div className="row">
                    <div className="col-12">
                        <div className="form-group">
                            <Select
                                className={"ads-finder"}
                                menuIsOpen={this.state.open}
                                ref={this.select}
                                cacheOptions
                                options={this.state.options}
                                onChange={(value) => {
                                    this.handleChange(value);
                                }}
                            />

                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default withNamespaces('common')(onClickOutside(AdsFinder));
